'use client'

import { Headline } from './Headline'
import { Column, Grid } from './Grid'
import { Container } from './Container'
import { imageLoader } from '@/loaders/index'
import lesson5 from '@/public/images/lesson-5.png'
import lesson6 from '@/public/images/lesson-6.png'
import lesson7 from '@/public/images/lesson-7.png'
import lesson8 from '@/public/images/lesson-8.png'
import Image from 'next/image'

export function LearnSectionDark({
  className = ''
}) {
  return (
    <section className={`${className}`} id="whats-inside">
      <Container withPattern>
        <Grid className='pt-[90px] md:pt-[160px] pb-[40px] md:pb-[80px] md:border-none flex-col md:flex-row'>
          <Column className='md:w-[40%]'>
            <Headline tag='h1' color='white' className='text-[40px] md:text-[60px] leading-[1.15] mb-[30px] md:mb-0' weight={600}>
              What Will <br/> You <em className='font-accent font--primary font-thin text-[48] md:text-[70px]'>Learn ?</em>
            </Headline>
          </Column>
          <Column className='md:w-[60%]'>
            <div className='flex flex-col md:flex-row font--primary text-[18px]'>
              <p className='md:max-w-[270px] md:mr-[60px] leading-[1.6] mb-[30px] md:mb-0'>This course equips entrepreneurs with the ultimate science-backed and field-tested method to easily find your biggest opportunities in business and <b>get them done.</b></p>
              <p className='md:max-w-[270px] leading-[1.6]'>Use the same systems as our coaches to take control, achieve any goal, and design your future like an architect, even in the face of life’s twists and turns.</p>
            </div>
          </Column>
        </Grid>
        <Grid className='pb-[60px] md:pb-[100px] flex-col md:flex-row' id="syllabus">
          <Grid className='flex-col md:bg-[#202D3A] rounded-[20px] md:pb-[50px]'>
            <Column className='flex md:mt-[50px] md:ml-[20%] flex-col md:flex-row mr-[20px] md:mr-0'>
              <p className='md:w-[85%] font--primary text-[18px] md:mt-[30px]'>Learn the evidence-based weekly planning ritual that turbo-charges your effectiveness as an entrepreneur and leader. This proven meta-habit will clarify and accelerate everything else in your life, without being complicated or hard to maintain.</p>
            </Column>
            <div className='flex mt-[50px] md:ml-[20%] flex-col md:flex-row md:mr-[20px] md:mr-0'>
              <div className='md:w-[50%] pb-[16px] md:pb-[36px] shrink-0 md:pl-0 md:pr-[80px] md:border-b md:border-[#414450]'>
                <Headline tag='h4' color='white' weight={700} className='text-[24px] md:text-[34px] mb-[16px] md:mb-[30px] leading-[1.2]'>Create A Weekly Ritual That Will Make You An Idol Of Efficiency</Headline>
                <p className='font--primary text-[18px]'>Unlock the psychological power of rituals, and how these sacred ceremonies can turn you into the most effective entrepreneur in your circle.</p>
              </div>
              <div className='md:w-[50%] md:pl-0 md:ml-0 md:mr-[80px] pb-[46px] border-b border-[#414450]'>
                <Image
                  src={lesson5}
                  alt='Lesson 5'
                  loader={imageLoader}
                />
              </div>
            </div>
            <div className='flex mt-[50px] md:ml-[20%] flex-col md:flex-row md:mr-[20px md:mr-0'>
              <div className='md:w-[50%] pb-[16px] md:pb-[36px] shrink-0 md:pl-0 md:pr-[80px] md:border-b md:border-[#414450]'>
                <Headline tag='h4' color='white' weight={700} className='text-[24px] md:text-[34px] mb-[16px] md:mb-[30px] leading-[1.2]'>Beat Stress & Delegate Like A Pro With Our Smart Reflection System</Headline>
                <p className='font--primary text-[18px]'>Become a master tactician with your time and tasks so you go into every week with clarity and confidence, knowing that nothing important will ever fall through the cracks.</p>
              </div>
              <div className='md:w-[50%] md:pl-0 md:ml-0 md:mr-[80px] pb-[46px] border-b border-[#414450]'>
                <Image
                  src={lesson6}
                  alt='Lesson 6'
                  loader={imageLoader}
                />
              </div>
            </div>
            <div className='flex mt-[50px] md:ml-[20%] flex-col md:flex-row md:mr-[20px md:mr-0'>
              <div className='md:w-[50%] pb-[16px] md:pb-[36px] shrink-0 md:pl-0 md:pr-[80px] md:border-b md:border-[#414450]'>
                <Headline tag='h4' color='white' weight={700} className='text-[24px] md:text-[34px] mb-[16px] md:mb-[30px] leading-[1.2]'>Identify Your Biggest Opportunities With 100% Certainty Every Week</Headline>
                <p className='font--primary text-[18px]'>Learn how to purge the overwhelming mental to-do lists, get laser-focused on where you can make a huge impact, and forget the rest.</p>
              </div>
              <div className='md:w-[50%] md:pl-0 md:ml-0 md:mr-[80px] pb-[46px] border-b border-[#414450]'>
                <Image
                  src={lesson7}
                  alt='Lesson 7'
                  loader={imageLoader}
                />
              </div>
            </div>
            <div className='flex mt-[50px] md:ml-[20%] flex-col md:flex-row md:mr-[20px md:mr-0'>
              <div className='md:w-[50%] pb-[16px] md:pb-[36px] shrink-0 md:pl-0 md:pr-[80px]'>
                <Headline tag='h4' color='white' weight={700} className='text-[24px] md:text-[34px] mb-[16px] md:mb-[30px] leading-[1.2]'>The Psychological Toolbox That Puts Taking Action On Autopilot</Headline>
                <p className='font--primary text-[18px]'>Stack all the proven techniques from the field of psychology into your weekly plans so you can guarantee you’ll get it all done. No more relying on willpower!</p>
              </div>
              <div className='md:w-[50%] md:pl-0 md:ml-0 md:mr-[80px] pb-[46px]'>
                <Image
                  src={lesson8}
                  alt='Lesson 8'
                  loader={imageLoader}
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </Container>
    </section>
  )
}
